import cloneDeep from 'lodash/cloneDeep';

import moment from 'moment';
import qs from 'qs';

import { handleActions } from 'redux-actions';
import axios from 'axios';
import endpoints from '../../config/endpoints';
import intl from '../shared/intl';
import checkPermissions from '../shared/check-permissions';
import { default as createCalendar, getDateRangeFromCalendar } from '../shared/calendar';
import { actions as rootActions } from '../root';

const calendar = createCalendar({
	namespace: 'affiliateReports',
	stateNodeName: 'calendar',
	defaultValue: {
		start: moment()
			.subtract('1', 'month')
			.format('YYYY-MM-DD'),
		end: moment().format('YYYY-MM-DD')
	}
});

// actions types
const FETCH_DATA_SUCCESS = 'affiliate-reports/fetch-data-success';
const TOGGLE_PROGRESS_BAR = 'affiliate-reports/toggle-progress-bar';

const GET_AFFILIATE_REPORTS_SUCCESS = 'affiliate-reports/get-report-success';
const GET_AFFILIATE_REPORTS_ERROR = 'affiliate-reports/get-report-error';

// permissions
export const allowedPermissions = {
	view: 'affiliate_reports_view'
};

// initial state
const initialState = {
	data: null,
	calendar: calendar.initialState,
	showProgressBar: false,
	error: false
};

// actions
export const actions = Object.assign(
	{
		fetchData: () => dispatch => {
			setTimeout(() => dispatch({ type: FETCH_DATA_SUCCESS }), 1);
		},

		getReport: () => (dispatch, getState) => {
			const { calendar } = getState().affiliateReports;
			const date_range = getDateRangeFromCalendar(calendar);
			let url = `${endpoints.AFFILIATE_REPORTS.BASE}/?${qs.stringify({ date_range })}`;

			dispatch(rootActions.spinnerToggle());
			return axios({
				url,
				method: 'GET',
				responseType: 'blob'
			}).then((response) => {
				dispatch(rootActions.spinnerToggle());
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				const startDate = moment(date_range.start).format('DD.MM.YYYY');
				const endDate = moment(date_range.end).format('DD.MM.YYYY');
				const filename = `Пользователи за период с ${startDate} по ${endDate}.csv`;
				link.href = url;
				link.setAttribute('download', filename);
				document.body.appendChild(link);
				link.click();
			})
				.catch(() => {
					dispatch(rootActions.spinnerToggle());
				});
		},

		toggleProgressBar: () => ({
			type: TOGGLE_PROGRESS_BAR
		})
	},
	calendar.actions
);

// reducers
const reducers = Object.assign(
	{
		// placeholder data needed because of state machine and init func = fetchData
		[FETCH_DATA_SUCCESS]: (state, action) => ({ ...state, data: 'placeholder' }),
		[GET_AFFILIATE_REPORTS_SUCCESS]: (state, action) => ({ ...state, showProgressBar: false }),
		[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar }),
		[GET_AFFILIATE_REPORTS_ERROR]: state => ({ ...state, error: true })
	},
	calendar.reducers
);

export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.affiliateReports.data,
	getCalendar: state => calendar.selectors.getCalendar(state => state.affiliateReports.calendar, state => state)(state),
	getIntl: state => intl(state),
	getProgressBar: state => state.finReports.showProgressBar,
	getCan: state => checkPermissions(state, allowedPermissions),
	getError: state => state.finReports.error
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliate-reports/index.js